import { BrowserPlan } from "../api-services/ai-chat";
import {
  BROWSER_PLANS_TAG_OPEN,
  BROWSER_PLANS_TAG_CLOSE,
  EXTENSION_ONLY_ACTIONS,
  BROWSER_PLANS_ERROR_MESSAGES,
} from "../commons/ai-chat.constants";

type BrowserPlansPayload = {
  matchedPlans?: BrowserPlan[];
};

export const extractBrowserPlansFromContent = (
  raw: string
): { cleanedContent: string; plans: BrowserPlan[] } => {
  const openIdx = raw.indexOf(BROWSER_PLANS_TAG_OPEN);
  const closeIdx = raw.indexOf(BROWSER_PLANS_TAG_CLOSE);

  if (openIdx === -1 || closeIdx === -1 || closeIdx <= openIdx) {
    return { cleanedContent: raw, plans: [] };
  }

  const before = raw.slice(0, openIdx).trimEnd();
  const jsonStr = raw
    .slice(openIdx + BROWSER_PLANS_TAG_OPEN.length, closeIdx)
    .trim();
  const after = raw
    .slice(closeIdx + BROWSER_PLANS_TAG_CLOSE.length)
    .trimStart();

  let plans: BrowserPlan[] = [];

  try {
    const parsed = JSON.parse(jsonStr) as BrowserPlansPayload & {
      // eslint-disable-next-line camelcase
      matched_plans?: BrowserPlan[];
    };
    // Handle both snake_case and camelCase keys from backend
    const plansArray = parsed.matchedPlans || parsed.matched_plans;
    if (parsed && Array.isArray(plansArray)) {
      plans = plansArray.map((plan) => ({
        ...plan,
        // Filter out extension-only actions
        actions: plan.actions?.filter(
          (action) => !(EXTENSION_ONLY_ACTIONS as readonly string[]).includes(action.id)
        ),
      }));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(BROWSER_PLANS_ERROR_MESSAGES.PARSE_FAILED, {
      jsonStr,
      error,
    });
  }

  let cleanedContent = before;
  if (after) {
    cleanedContent = cleanedContent ? `${cleanedContent}\n\n${after}` : after;
  }

  return { cleanedContent: cleanedContent || raw, plans };
};
